import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import * as api from "../../../../shared/lib/api";
import { ApiProps, ListAllApiProps } from "../../types/api";

type ApiAutocompleteFilterProps = {
	value: string;
	onChange: (apiId: string) => void;
	label?: string;
	placeholder?: string;
	variant?: "outlined" | "standard";
	fullWidth?: boolean;
};

export default function ApiAutocompleteFilter({
	value,
	onChange,
	label = "API",
	placeholder = "Digite o nome da API",
	variant = "outlined",
	fullWidth = false,
}: ApiAutocompleteFilterProps): JSX.Element {
	const [apis, setApis] = useState<ApiProps[]>([]);

	useEffect(() => {
		api
			.get("api/list/all/")
			.then((response) => {
				const content = (response as ListAllApiProps)?.content;
				setApis(Array.isArray(content) ? content : []);
			})
			.catch(() => setApis([]));
	}, []);

	return (
		<Autocomplete
			size={variant === "outlined" ? "small" : "medium"}
			sx={{ width: fullWidth ? "100%" : { xs: "100%", sm: 400 } }}
			options={apis}
			getOptionLabel={(option) => option.name}
			isOptionEqualToValue={(option, selected) => option.id === selected.id}
			value={apis.find((item) => item.id === value) ?? null}
			onChange={(_event, option) => onChange(option?.id ?? "")}
			noOptionsText="Nenhuma API encontrada"
			clearText="Limpar"
			openText="Abrir"
			closeText="Fechar"
			renderInput={(params) => (
				<TextField
					{...params}
					variant={variant}
					label={label}
					placeholder={placeholder}
				/>
			)}
		/>
	);
}
